/**
 * Time picker as a <select> with 15-minute increments.
 * Value format: "HH:MM" (24-hour) or empty string for no selection.
 */

const TIME_OPTIONS: { value: string; label: string }[] = [];
for (let h = 0; h < 24; h++) {
  for (const m of [0, 15, 30, 45]) {
    const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    const ampm = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 || 12;
    const label = `${hour12}:${String(m).padStart(2, '0')} ${ampm}`;
    TIME_OPTIONS.push({ value, label });
  }
}

interface TimeSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

export function TimeSelect({ value, onChange, className = '', placeholder = '—' }: TimeSelectProps) {
  // If the current value isn't on a 15-min boundary, include it so it's not lost
  const hasNonStandard = value && !TIME_OPTIONS.some(o => o.value === value);

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className={className}
    >
      <option value="">{placeholder}</option>
      {hasNonStandard && <option value={value}>{formatTime(value)}</option>}
      {TIME_OPTIONS.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}

function formatTime(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${ampm}`;
}
